import { observer } from 'mobx-react';
import styled from 'styled-components';
import { theme } from 'client/widgets/lib';
import { browser, globalPageConfig, user } from 'lib';

import S from './styled';
import React from 'react';
import { useStore } from 'client/widgets/functions/popup-login/store';
import { useGlobalStore } from 'stores';

const { FormItem } = S;

const StyledOneLogin = styled.div`
  display: flex;
  box-sizing: border-box;
  align-items: center;
  color: #c3c3c3;
  font-size: var(--fs-base);
  padding-top: 20px;
  width: 100%;
  span {
    margin-right: 14px;
  }
  .qq,
  .wechat,
  .weibo {
    width: 40px;
    height: 40px;
    cursor: pointer;
  }
  .qq {
    background: url(${require('./images/qq.png')}) 0 0 / contain no-repeat;
  }
  .weibo {
    background: url(${require('./images/weibo.png')}) 0 0 / contain no-repeat;
  }
  .wechat {
    background: url(${require('./images/wechat.png')}) 0 0 / contain no-repeat;
  }
`;

const OneLogin = observer(() => {
  const { setLoginType } = useStore();
  const { isPcClient, isPcWeb } = useGlobalStore();
  const { enableWeibo } = globalPageConfig.useConfig();

  const onLogin = (e) => {
    const { type } = e.currentTarget.dataset;
    user.redirectThirdLogin(type);
  };
  return (
    <StyledOneLogin>
      <span>一键登录</span>
      <span className="qq" data-type="qq" onClick={onLogin} title="QQ登录"></span>
      <span className="wechat" data-type="wechat" onClick={onLogin} title="微信登录"></span>
      {enableWeibo && (
        <span className="weibo" data-type="sina" onClick={onLogin} title="微博登录"></span>
      )}
      {isPcWeb && (
        <ToggleLogin
          onClick={() => {
            setLoginType('register');
          }}
        >
          立即注册
        </ToggleLogin>
      )}
    </StyledOneLogin>
  );
});

const ToggleLogin = styled.span`
  cursor: pointer;
  color: ${theme.color.second};
  height: 24px;
  font-size: var(--fs-md);

  &.bar {
    margin: 0 5px;
  }
  &:hover {
    text-decoration: underline;
    //color: ;
  }
`;

export { OneLogin, ToggleLogin };
